
var finansudd = finansudd || {};

finansudd.scrollTo = new function(){

    var self = this;

    this.init = function (selector) {

    	selector.click(function(e) {
    		e.preventDefault();
            self.scrollTarget(this.hash);
    	});

	};

	this.scrollTarget = function(target, trans, offset) {

		var transition = trans === undefined ? 750 : trans;

		var target_offset = $(target).offset() != null ? $(target).offset().top : 0;
		//change this number to create the additional off set        
		var customoffset = offset ? offset: 75; 
		$('html, body').animate({scrollTop:target_offset - customoffset}, transition);
		
	}

};